import Input from "./Input";

export default function UnitCostInput({
  quantity,
  fieldName,
}: {
  quantity: number;
  fieldName: string;
}) {
  return (
    <div>
      <Input
        keyPath={["by_quantity", quantity.toString(), fieldName]}
        className="font-semibold"
        unit="currency"
        alignRight
      />
      <Input
        keyPath={["by_quantity", quantity.toString(), fieldName]}
        unit="currency"
        alignRight
        transformFns={{
          initialValue: (value) => initialValue(value, quantity),
          saveValue: (value) => saveValue(value, quantity),
        }}
      />
    </div>
  );
}

function maybeGetNumericalValue(value: string | null) {
  if (!value) return null;
  const numValue = Number(value);
  return isNaN(numValue) ? null : numValue;
}

function initialValue(value: string | null, quantity: number) {
  const numValue = maybeGetNumericalValue(value);
  return numValue ? (numValue / quantity).toString() : null;
}

function saveValue(value: string | null, quantity: number) {
  const numValue = maybeGetNumericalValue(value);
  return numValue ? (numValue * quantity).toString() : null;
}
